import { GridCurrencyCellComponent } from '../../../components/templates/currency/currency.component';
import { NumberCol } from '../number/number-col';
import { CurrencyEditorComponent } from './currency-editor.component';

export class CurrencyCol extends NumberCol {
  public override getColDef() {
    return {
      ...super.getColDef(),
      ...{
        aggFunc: 'sum',
        cellEditor: CurrencyEditorComponent,
        cellRenderer: GridCurrencyCellComponent,
      },
    };
  }
}
